import bridge from './side-chat-bridge';
import { getChatIdParam } from './side-chat-url';
import { openSideChat } from './loomly-ai-chat-toggle';

const PROMPT =
  'Analyze my analytics for the selected period across all connected social channels and shortened URLs. ' +
  'Compare with the previous period and highlight key changes in followers, engagement, impressions, ' +
  'and link clicks. Identify the best and worst performing posts and top shortened URLs.';

let boundBtn = null;
let unsubStreaming = null;

function buildContext(btn) {
  return {
    provider: 'all_channels',
    start_day: btn.dataset.startDay,
    end_day: btn.dataset.endDay,
    compare_start_day: btn.dataset.compareStartDay || null,
    compare_end_day: btn.dataset.compareEndDay || null
  };
}

function syncDisabledState() {
  if (!boundBtn) return;
  const streaming = !!bridge.get('streaming')?.active;
  boundBtn.classList.toggle('disabled', streaming);
  boundBtn.setAttribute('aria-disabled', String(streaming));
}

function handleClick(e) {
  e.preventDefault();
  if (e.currentTarget.classList.contains('disabled')) return;

  bridge.emit('analyticsContext', buildContext(e.currentTarget));

  const chatId = getChatIdParam();
  if (chatId && chatId !== 'new') {
    openSideChat();
    return;
  }

  bridge.openChatWithPrompt(PROMPT);
}

function setup() {
  const btn = document.getElementById('analytics-ai-chat-btn');

  if (!btn) {
    if (boundBtn) {
      boundBtn.removeEventListener('click', handleClick);
      boundBtn = null;
    }
    if (unsubStreaming) { unsubStreaming(); unsubStreaming = null; }
    bridge.emit('analyticsContext', null);
    return;
  }

  if (btn !== boundBtn) {
    if (boundBtn) boundBtn.removeEventListener('click', handleClick);
    if (unsubStreaming) unsubStreaming();
    btn.addEventListener('click', handleClick);
    boundBtn = btn;
    unsubStreaming = bridge.on('streaming', syncDisabledState);
    syncDisabledState();
  }

  if (bridge.get('analyticsContext')) {
    bridge.emit('analyticsContext', buildContext(btn));
  }
}

document.addEventListener('turbo:load', setup);

document.addEventListener('turbo:frame-load', (e) => {
  if (e.target.id === 'loomly-ai-main-frame') setup();
});

document.addEventListener('turbo:before-render', (e) => {
  const newBody = e.detail?.newBody;
  if (!newBody) return;
  if (bridge.get('analyticsContext') && !newBody.querySelector('#analytics-ai-chat-btn')) {
    bridge.emit('analyticsContext', null);
  }
});
